import { Badge, clsx, Icon } from "@alpacahq/ui/old";

import {
  useGetCurrentAccountIfLiveElseTradingAccount,
  useGetIPFilters,
} from "~/v2/api/hooks";

export const IPAllowlist = () => {
  // TODO (MLA): Review UX
  const { account } = useGetCurrentAccountIfLiveElseTradingAccount();
  const { data, isLoading } = useGetIPFilters({
    accountID: account?.id,
    options: { enabled: !!account?.account_number },
  });

  const cidrs = data?.cidrs ?? [];
  const enabled = cidrs.length > 0;

  const loader = (
    <tr className="bg-white">
      <td className="px-3 py-2.5">...</td>
    </tr>
  );

  const rows = cidrs.map((cidr, index) => (
    <tr
      key={cidr}
      className={clsx(
        "border-zinc-200 border-b bg-white",
        index % 2 === 0 && "bg-zinc-100",
      )}
    >
      <td className="px-3 py-2.5">{cidr}</td>
    </tr>
  ));

  return (
    <div className="w-full max-w-[600px]">
      <h2 className="mb-5 font-bold text-xl">IP Allowlist</h2>
      <Badge variant={enabled ? "emerald" : "rose"}>
        <Icon
          name={enabled ? "ShieldCheck" : "ShieldExclamation"}
          className="mr-1"
          size="sm"
        />
        {enabled ? "Enabled" : "Disabled"}
      </Badge>
      <div className="my-4 overflow-clip overflow-x-scroll rounded-lg border border-zinc-200 p-0">
        <table className="w-full whitespace-nowrap text-sm">
          <tbody>
            <tr className="border-zinc-200 border-b">
              <td className="px-3 py-2.5 font-medium">CIDR</td>
            </tr>
            {isLoading ? loader : rows}
          </tbody>
        </table>
      </div>
    </div>
  );
};
